import React, {Suspense} from 'react';
import {RouterProvider} from 'react-router-dom';
import {Provider} from 'react-redux';
import {reduxStore} from 'services/reduxStore';
import {ErrorBoundary} from 'react-error-boundary';
import MainTheme from 'theme';
import {ThemeProvider} from 'styled-components';
import {OverrideStyles} from 'theme/overrideStyles';
import Loader from 'components/GeneralComponents/Loader';
import NotificationsContainer from 'components/GeneralComponents/NotificationsContainer';
import ErrorFallback from 'components/GeneralComponents/ErrorFallback';
import {router} from 'components/GeneralComponents/Routers';

const App = () => (
  <Provider store={reduxStore}>
    <ThemeProvider theme={MainTheme}>
      <ErrorBoundary FallbackComponent={ErrorFallback}>
        <Suspense fallback={<Loader />}>
          <RouterProvider router={router} />
          <NotificationsContainer hideProgressBar={false} pauseOnHover autoClose={5000} />
        </Suspense>
        <OverrideStyles />
      </ErrorBoundary>
    </ThemeProvider>
  </Provider>
);

export default App;
